module.exports = __webpack_public_path__ + "assets/images/EUR20.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR20.png
// module id = 1366
// module chunks = 1